/**
 * FeatureList - Gjenbrukbar liste over funksjoner
 * Brukes i alle modul-modaler
 */
export function FeatureList({ features }) {
  return (
    <div className="space-y-2">
      {features.map((feature, index) => (
        <div 
          key={index} 
          className="flex items-start gap-3 p-3 rounded-lg bg-[var(--bg-highlight)]/30 border border-[var(--border-subtle)]"
        >
          <span className="text-sm">•</span>
          <p className="text-sm text-[var(--text-muted)]">{feature}</p>
        </div>
      ))}
    </div>
  );
}

export default FeatureList;
